import { ComposerSection, ComposerSectionProps } from '../types';

export const isComposerSection = (part: any): part is ComposerSection<ComposerSectionProps> =>
  (part as ComposerSection<ComposerSectionProps>).craft !== undefined;
